module.exports = __webpack_public_path__ + "img/icon-clear.d1000280.svg";